import classNames from 'classnames';

import { MenuItemType } from '@/hooks/useMenuItems';

import SvgIcon from '../common/SvgIcon';

import Icon, { IconProps } from './Icon';

export type MenuItemProps = MenuItemType & {
  active: boolean;
  extraClass?: string;
  onClick: Function;
  useSvg?: boolean;
};

const MenuItem = ({ onClick, active, icon, id, name, extraClass, useSvg = false }: MenuItemProps) => {
  const faIcon = icon.includes('fa');
  return (
    <li className={classNames('MenuItem d-flex', extraClass, active ? 'active fw-600' : 'inactive fw-500')} onClick={() => onClick(id)}>
      {faIcon && (
        <span className="d-flex justify-content-center align-center">
          <Icon icon={icon.substring(2) as IconProps['icon']} size="2xs" style={{ width: '16px' }} fixedWidth></Icon>
        </span>
      )}
      {!useSvg && !faIcon && <span className={`icon-${icon} f-14`} />}
      {!faIcon && icon && useSvg && (
        <span className="d-flex justify-content-center align-center">
          <SvgIcon alt={icon} filename={icon}></SvgIcon>
        </span>
      )}
      <p className="menuTitle m-2 f-16">{name}</p>
    </li>
  );
};

export default MenuItem;
